module.exports = __webpack_public_path__ + "static/media/kuban-thumb.183ec2b2.png";